import { render, staticRenderFns } from "./VendorInvoiceForm.vue?vue&type=template&id=3198dd26&scoped=true&"
import script from "./VendorInvoiceForm.vue?vue&type=script&lang=js&"
export * from "./VendorInvoiceForm.vue?vue&type=script&lang=js&"
import style0 from "./VendorInvoiceForm.vue?vue&type=style&index=0&id=3198dd26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3198dd26",
  null
  
)

export default component.exports